import {
  SET_TOOL_VISIBLE,
  SET_TOOL_COLLAPSED,
  SET_TOOL_POSITION,
  SET_LAYER_SETTINGS_LAYER,
  SET_GROUP_SETTINGS_GROUP,
  SET_MAPVIEW_SETTINGS_GROUP,
  SET_DRAW_TARGET_LAYER,
  CLOSE_LAYER_SETTINGS,
  CLOSE_GROUP_SETTINGS,
  INITIALIZE_TOOLS_STATE,
} from './types'
import type { DrawTargetLayer, ToolName } from '@/containers/Tools/types'
import type { Layer } from '@/containers/Toc/context/types'

// =============================================================================
// Tool Visibility Actions
// =============================================================================

export const setToolVisible = (toolName: ToolName, visible: boolean) => ({
  type: SET_TOOL_VISIBLE,
  payload: { toolName, visible },
})

export const setToolCollapsed = (toolName: ToolName, collapsed: boolean) => ({
  type: SET_TOOL_COLLAPSED,
  payload: { toolName, collapsed },
})

export const setToolPosition = (
  toolName: ToolName,
  positionX: number | null,
  positionY: number | null
) => ({
  type: SET_TOOL_POSITION,
  payload: { toolName, positionX, positionY },
})

// =============================================================================
// LayerSettings Actions
// =============================================================================

export const setLayerSettingsLayer = (layer: Layer | null) => ({
  type: SET_LAYER_SETTINGS_LAYER,
  payload: { layer },
})

export const closeLayerSettings = () => ({
  type: CLOSE_LAYER_SETTINGS,
})

// =============================================================================
// GroupSettings Actions
// =============================================================================

export const setGroupSettingsGroup = (group: Layer | null) => ({
  type: SET_GROUP_SETTINGS_GROUP,
  payload: { group },
})

export const closeGroupSettings = () => ({
  type: CLOSE_GROUP_SETTINGS,
})

// =============================================================================
// MapViewSettings Actions
// =============================================================================

export const setMapViewSettingsGroup = (
  mapViewGroup: Record<string, unknown> | null
) => ({
  type: SET_MAPVIEW_SETTINGS_GROUP,
  payload: { mapViewGroup },
})

// =============================================================================
// Draw Actions
// =============================================================================

export const setDrawTargetLayer = (targetLayer: DrawTargetLayer | null) => ({
  type: SET_DRAW_TARGET_LAYER,
  payload: { targetLayer },
})

// =============================================================================
// Initialization
// =============================================================================

export const initializeToolsState = () => ({
  type: INITIALIZE_TOOLS_STATE,
})
